// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "mail." + chunkId + "." + {"134":"373829c0fef5c02323a6","389":"214a82849deb4845e9e1","454":"46a7256a2e184cdb361e","471":"bdf7ee551f1a2e6dfc94","640":"fe01d78de2a504ee90f1","771":"f4d6320500c9b3153fbf","774":"7708eda4411a7f9f29ad"}[chunkId] + ".js";
};